export const CHAT_QUERY_KEYS = {
  queries: {
    session: (sessionId: string) => ['auth', 'session', sessionId],
    sessions: () => ['auth', 'sessions'],
  },

  mutations: {
    createNewChat: () => ['auth', 'session', 'create'],
    sendFirstChatMessage: () => ['auth', 'session', 'create', 'first-message'],

    sendMessageToChat: () => ['auth', 'session', 'send-message'],
  },
};
